import { useState } from "react";
import {
  ChatworkApi,
  ChatworkSendPostRequest,
  RequestChatworkSendMessageRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiChatworkSend = () => {
  const [result, setResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const sendChatwoekMessage = async (
    req: RequestChatworkSendMessageRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: ChatworkSendPostRequest = {
        req,
      };

      const api = new ChatworkApi(config);
      const response = await api.chatworkSendPost(request);
      setResult(response);
      return response;
    } catch (err) {
      setError("チャットワークでのメッセージ送信に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { sendChatwoekMessage, result, error, isLoading };
};
